import useSWRMutation from "swr/mutation";
import { environment } from "../config/environment";
import { EmailResponseModel } from "../models/EmailModels";
import { useAuth0 } from "@auth0/auth0-react";
import { useSWRFetcher } from "./useSWRFetcher";

export const useGetEmailContent = () => {
  const fetcher = useSWRFetcher();
  const { user } = useAuth0();

  const { trigger, isMutating, error } = useSWRMutation(
    `${environment.apiUrl}/api`,
    (url: string, { arg }: { arg: { path: string; relatedIds?: string[]; receivedEmailContent?: string } }) =>
      fetcher<EmailResponseModel>(`${url}/${arg.path}`, {
        method: "POST",
        body: JSON.stringify({
          senderName: user?.name,
          ids: arg.relatedIds,
          recievedEmailContent: arg.receivedEmailContent,
        }),
      })
  );

  return {
    getEmailContent: trigger,
    isLoading: isMutating,
    isError: !!error,
  };
};
